var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"sm":12,"md":7,"lg":3,"xl":3}},[_c('div',{staticClass:"tes-card pa-5"},[_c('div',{staticClass:"mt-6 text-center"},[_c('span',[_vm._v("\n                "+_vm._s(_vm.textNotification)+"\n            ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }